import Vue from 'vue';
import ChatBuider from '@/services/chat-builder.service';
import api from '@/api';
import { modals } from '@/constants/modals.constant';
import { REMOTE_PATHS } from '@/constants/remote-paths.constant';
import { Socket } from 'phoenix';

const state = {
  chatBuilder: new ChatBuider(),
  messages: [],
  nextToken: '',
  chatChannelName: null,
  phoenixSocket: null,
  channel: null,
  unreadMessagesCount: 0
};

const getters = {
  messages(state) {
    return state.messages;
  },

  messagesEnded(state) {
    return !state.nextToken || state.nextToken === '';
  },

  unreadMessagesCount(state) {
    const count = state.unreadMessagesCount > 99 ? '99+' : state.unreadMessagesCount;
    return count || false;
  }
};

const actions = {
  joinChat({ state, commit, dispatch }, name) {
    commit('setChatChannelName', name);
    dispatch('connectChatSocket');
    dispatch('getChatMessages');
  },

  sendChatMessage({ state, commit, dispatch, rootState }, { type, data }) {
    let body;
    switch (type) {
      case 'text':
        body = state.chatBuilder.createTextMessageBody(
          data,
          rootState.conference.user.userId
        );
        break;
      case 'ping':
        body = state.chatBuilder.createPingMessageBody(
          rootState.conference.user.userId
        );
        break;
      case 'image':
        body = state.chatBuilder.createImageMessageBody(
          data,
          rootState.conference.user.userId
        );
        break;
      default:
        break;

    }
    api.sendChatMessage(body, state.chatChannelName).then(payload => {
      const decoded = state.chatBuilder.decodePutMessageResponse(payload.data);
    });
  },

  sendChatImage({ state, commit, dispatch }, { file, onprogress }) {
    return new Promise((resolve, reject) => {
      api.uploadImage(file, onprogress).then(response => {
        const w = Math.floor((Math.random() * 1879) + 50);
        const h = Math.floor((Math.random() * 1879) + 50);
        dispatch('sendChatMessage', {
          type: 'image',
          data: {
            imageUrl: `http://via.placeholder.com/${w}x${h}`,
            imageWidth: w,
            imageHeight: h
          }
        });
        resolve();
      });
    });
  },

  getChatMessages({ state, commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 20,
        next_token: state.nextToken
      };
      if (state.nextToken === '') {
        state.messages = [];
      }
      api.getChatMessages(state.chatChannelName, params).then(payload => {
        const decoded = state.chatBuilder.decodeChatResponse(payload.data);
        state.messages = state.messages.concat(decoded.messages);
        state.nextToken = decoded.nextToken;
        if (!rootState.conference.aside) {
          state.unreadMessagesCount += decoded.messages.length;
        }
        resolve(!decoded.nextToken);
      });
    });
  },

  sendInviteMessages({ state, commit, dispatch }, { users, url, username, pin }) {
    dispatch('toggleAside', 'invite-menu');
    const body = state.chatBuilder.createRpcSendMessageClientRequestBody(
      `You've been invited to @${username}'s conference call that starts now. Join using this KingsConference URL: ${url} or by inputting the following in the KingsConference app Username: ${username} and PIN: ${pin}`
    );
    users.forEach(id => {
      api.inviteUser(id, body);
    });
  },

  connectChatSocket({ state, commit, dispatch, rootState }) {
    const socketParams = {
      decode: (payload, callback) => {
        state.chatBuilder.decodeChatChannel(payload, callback);
      },
      params: {
        authorization: `Bearer ${Vue.prototype.$cookie.get('accessToken')}`
      }
    };
    state.phoenixSocket = new Socket(
      `${REMOTE_PATHS.WS_PATH}/conference/chat_channel`,
      socketParams
    );
    state.phoenixSocket.onConnMessage = response => {
      state.chatBuilder.decodeChatChannel(response.data, message => {
        state.messages.unshift(message);
        if (!rootState.conference.aside) {
          state.unreadMessagesCount += 1;
        }
      });
    };
    if (process.env.NODE_ENV !== 'development') {
      state.phoenixSocket.connect();
    }
    state.channel = state.phoenixSocket.channel(state.chatChannelName, {});
    state.channel.join()
      .receive('ok', ({messages}) => console.log('catching up', messages))
      .receive('error', ({reason}) => console.log('failed join', reason))
      .receive('timeout', () => console.log('Networking issue. Still waiting...'));
    state.channel.on('chat', message => {
      console.info('on chat', message);
    });
    state.channel.on('first_response', message => {
      console.info('on first_response', message);
    });
    state.channel.on('new_message', message => {
      console.info('on new_message', message);
    });
    state.channel.on('chat', message => {
      console.info('on chat', message);
    });
  },

  disconnectChat({ state, commit, dispatch }) {
    if (state.phoenixSocket) {
      state.phoenixSocket.disconnect();
    }
    commit('clearChatData');
  }
};

const mutations = {
  setChatChannelName(state, name) {
    state.chatChannelName = name;
  },

  clearChatData(state) {
    state.chatChannelName = null;
    state.messages = [];
    state.nextToken = '';
    state.phoenixSocket = null;
    state.channel = null;
  },

  resetUnreadMessagesCount(state) {
    state.unreadMessagesCount = 0;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/chat/chat.js